const FAQSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">❓ Câu Hỏi Thường Gặp</h2>

            <div className="space-y-4">
                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        🔐 Quên mật khẩu thì làm sao?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Liên hệ với giáo viên hoặc admin để được reset mật khẩu. Hiện tại chưa hỗ trợ tự động reset qua email.
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        💰 Đã chuyển khoản nhưng chưa được xác nhận?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Admin sẽ xác nhận trong vòng 24 giờ. Nếu quá 24h chưa được xác nhận, hãy liên hệ giáo viên
                        và cung cấp ảnh chụp giao dịch để được hỗ trợ nhanh hơn.
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        🤖 AI trả lời sai hoặc không chính xác?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        AI có thể đôi khi sai. Hãy:
                        <ul className="mt-2 list-disc list-inside space-y-1">
                            <li>Kiểm tra lại kết quả với giáo viên</li>
                            <li>Thử hỏi lại câu hỏi theo cách khác</li>
                            <li>Sử dụng GPT-4o thay vì GPT-4o-mini</li>
                            <li>Cung cấp thêm ngữ cảnh cho câu hỏi</li>
                        </ul>
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        📝 Làm sai bài kiểm tra có được làm lại không?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Tùy vào cài đặt của giáo viên. Một số bài cho phép làm lại nhiều lần, một số chỉ làm 1 lần.
                        Hãy kiểm tra thông tin bài kiểm tra trước khi bắt đầu.
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        📱 Có app mobile không?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Chưa có app riêng, nhưng website responsive hoàn toàn trên mobile. Bạn có thể:
                        <ul className="mt-2 list-disc list-inside space-y-1">
                            <li>Mở bằng trình duyệt trên điện thoại</li>
                            <li>Thêm vào màn hình chính để truy cập nhanh</li>
                            <li>Tất cả tính năng hoạt động bình thường</li>
                        </ul>
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        📊 Xem điểm trung bình ở đâu?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Vào <strong>Thông tin cá nhân</strong> (nhấn vào avatar góc phải) để xem thống kê
                        số bài đã làm, điểm trung bình và biểu đồ tiến trình.
                    </p>
                </details>

                <details className="bg-white p-6 rounded-lg border border-slate-200">
                    <summary className="font-semibold text-slate-900 cursor-pointer">
                        🔔 Có thông báo khi có bài tập mới không?
                    </summary>
                    <p className="mt-3 text-slate-700">
                        Hiện tại chưa hỗ trợ thông báo push. Bạn nên:
                        <ul className="mt-2 list-disc list-inside space-y-1">
                            <li>Kiểm tra Dashboard thường xuyên</li>
                            <li>Xem lịch học để biết deadline</li>
                            <li>Đặt nhắc nhở riêng trên điện thoại</li>
                        </ul>
                    </p>
                </details>
            </div>

            <div className="bg-indigo-50 p-6 rounded-lg border border-indigo-200">
                <h3 className="text-lg font-semibold text-indigo-900 mb-2">💬 Vẫn còn thắc mắc?</h3>
                <p className="text-slate-700">
                    Sử dụng tính năng <strong>"Hỗ trợ"</strong> để gửi câu hỏi cho giáo viên.
                    Hoặc nhắn tin trực tiếp trong trang lớp học để được hỗ trợ nhanh hơn!
                </p>
            </div>
        </div>
    );
};

export default FAQSection;
